import { useMutation } from '@tanstack/react-query';
import { backupService } from '@/services/backup';

export const useCreateBackup = () => {
  return useMutation<void, Error, void>({
    mutationFn: () => backupService.createBackup(),
  });
};


